import React from 'react';
import ReactDOM from 'react-dom';
import PlotContent from './PlotContent';

// Global reference to the popup window
let plotWindow = null;
let plotRoot = null;

// Function to open the plot window
export const openPlotWindow = (currentGameState, timeline, plotData) => {
  // If window is already open, focus it
  if (plotWindow && !plotWindow.closed) {
    plotWindow.focus();
    renderPlot(currentGameState, timeline, plotData);
    return;
  }

  console.log("data: ", plotData);
  
  // Open a new window
  plotWindow = window.open('', 'PlotWindow', 'width=800,height=600,left=200,top=200');
  
  if (!plotWindow) {
    alert('Please allow popups for this site to use the plotting feature.');
    return;
  }
  
  // Set title and create container
  plotWindow.document.title = 'Resource Evolution';
  
  // Create a container for our React component
  plotRoot = plotWindow.document.createElement('div');
  plotRoot.id = 'plot-root';
  plotWindow.document.body.innerHTML = ''; // Clear any existing content
  plotWindow.document.body.appendChild(plotRoot);
  
  // Copy styles from parent window
  copyStyles(document, plotWindow.document);
  
  // Add event listener for window close
  plotWindow.addEventListener('beforeunload', () => {
    plotWindow = null;
    plotRoot = null;
  });
  
  // Render the initial content
  renderPlot(currentGameState, timeline, plotData);
};

// Function to close the plot window
export const closePlotWindow = () => {
  if (plotWindow && !plotWindow.closed) {
    plotWindow.close();
    plotWindow = null;
    plotRoot = null;
  }
};

// Function to check if the plot window is open
export const isPlotWindowOpen = () => {
  return plotWindow !== null && !plotWindow.closed;
};

// Function to render content in the plot window
const renderPlot = (currentGameState, timeline, plotData) => {
  if (!plotWindow || !plotRoot || plotWindow.closed) return;
  
  ReactDOM.render(
    <PlotContent 
      currentGameState={currentGameState}
      plotData={plotData} 
    />,
    plotRoot
  );
};

// Function to update the plot with new data
export const updatePlot = (currentGameState, timeline, plotData) => {
  if (isPlotWindowOpen()) {
    renderPlot(currentGameState, timeline, plotData);
  }
};

// Function to copy styles from parent window to popup
const copyStyles = (sourceDoc, targetDoc) => {
  // Create a base style
  const baseStyle = targetDoc.createElement('style');
  baseStyle.textContent = `
    body { 
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
      margin: 0;
      padding: 0;
      background-color: #1a202c;
      color: white;
    }
  `;
  targetDoc.head.appendChild(baseStyle);
  
  // Copy all stylesheets
  Array.from(sourceDoc.styleSheets).forEach(styleSheet => {
    try {
      // Skip if styleSheet has no rules
      if (!styleSheet.cssRules) return;
      
      const newStyleEl = targetDoc.createElement('style');
      
      Array.from(styleSheet.cssRules).forEach(cssRule => {
        newStyleEl.appendChild(targetDoc.createTextNode(cssRule.cssText));
      });
      
      targetDoc.head.appendChild(newStyleEl);
    } catch (e) {
      // Some browsers throw when accessing cssRules for stylesheets from different origins
      console.warn('Error copying stylesheet:', e);
      
      // For stylesheets that can't be accessed directly, try to copy by creating a link
      if (styleSheet.href) {
        const linkEl = targetDoc.createElement('link');
        linkEl.rel = 'stylesheet';
        linkEl.href = styleSheet.href;
        targetDoc.head.appendChild(linkEl);
      }
    }
  });
};
